export default "__VITE_ASSET__DJGa5lx9__"